import {
  ExplorerEndpointPage,
  ExplorerErrorPage,
} from '@squareup/dex-feature-dex-tech-main-explorer-page';
import {
  useGraph,
  useGraphApi,
  useGraphEndpoint,
} from '@squareup/dex-feature-hooks-graph';
import { useSelectErrorState } from '@squareup/dex-store-access-shared-main-selectors';
import { ReferenceHrefBuilders, toUrl } from '@squareup/dex-tech-utils-routing';
import { Head } from '@squareup/dex-ui';
import {
  getNextPublicApiExplorerNameOrDefault,
  getNextPublicSquareDocsURL,
} from '@squareup/dex-utils-environment';
import { getStateNodeErrorStatusAndMessage } from '@squareup/dex-utils-error';
import { useParams } from '@squareup/dex-utils-shared-routing-hooks';
import React from 'react';

import ExplorerBasePage from '../../../../shared/ExplorerBasePage';
import { explorerGetInitialProps } from '../../../../shared/explorer-get-initial-props';

const PageContent = () => {
  const { graph } = useGraph();
  const { endpoint } = useGraphEndpoint();
  const { api } = useGraphApi();
  const query = useParams();
  const square_version = query?.square_version as string;

  const errorState = useSelectErrorState();
  const errorStatusAndMessage = getStateNodeErrorStatusAndMessage(
    errorState.global || errorState.page
  );

  const description = endpoint
    ? `Try out the ${endpoint?.name} endpoint in Square’s API Explorer`
    : '';

  const canonicalPath =
    api && endpoint
      ? toUrl(
          ReferenceHrefBuilders.versionSquareExplorerEndpoint({
            square_version,
            api: `${api.id}-api`,
            endpoint: endpoint?.id,
          })
        )
      : undefined;

  const title =
    api && endpoint
      ? `${endpoint.httpMethod.toUpperCase()} ${
          endpoint.path
        } - Square API Explorer`
      : getNextPublicApiExplorerNameOrDefault();

  const head = (
    <Head
      title={title}
      description={description}
      canonicalPath={canonicalPath}
      preconnectUrl={getNextPublicSquareDocsURL()}
    />
  );

  if (errorStatusAndMessage) {
    return (
      <>
        {head}
        <ExplorerErrorPage graph={graph} error={errorStatusAndMessage} />
      </>
    );
  } else if (!graph || !endpoint || !api) {
    return null;
  } else {
    return (
      <>
        {head}
        <ExplorerEndpointPage graph={graph} endpoint={endpoint} api={api} />
      </>
    );
  }
};

const Page = () => {
  return (
    <ExplorerBasePage>
      <PageContent />
    </ExplorerBasePage>
  );
};

Page.getInitialProps = explorerGetInitialProps;

export default Page;
